import React from 'react';

type Props = {
  text: string,
  onClickApplyAlerts: () => void
  disabled: boolean
};

const ApplyAlerts = function ApplyAlerts(props: Props) {
  const { text, onClickApplyAlerts, disabled } = props;
  return (
    <div className={`btn-wrapper ${disabled ? 'disabled' : ''}`}>
      <span className="apply-alerts" onClick={onClickApplyAlerts} onKeyPress={onClickApplyAlerts} tabIndex={0} role="button" aria-label="apply-alerts">{text}</span>
    </div>
  );
};

export default ApplyAlerts;
